export default __webpack_public_path__ + "static/media/default_organization_placeholder.deb3bbce.svg";